import { FlatList } from 'react-native'

import { Stack } from '@zet/design-system/layout'
import { SH3 } from '@zet/design-system/typography'

import { useGetHomePageTopBrand } from '../../api/homeScreenBridge/hooks'
import { i18n } from '../../localization'
import BrandCard from './BrandCard'

const TopBrands = () => {
  const { data } = useGetHomePageTopBrand()

  if (!data?.data?.length) {
    return <></>
  }

  return (
    <Stack className="mb-2 bg-white px-3 py-3">
      <SH3>{i18n.t('botomTab.topBrands')}</SH3>
      <FlatList
        data={data?.data}
        horizontal={true}
        renderItem={({ item, index }) => (
          <BrandCard item={item} index={index + 1} key={`index-${index}`} />
        )}
        showsHorizontalScrollIndicator={false}
      />
    </Stack>
  )
}

export default TopBrands
